import { render, staticRenderFns } from "./CPU.vue?vue&type=template&id=1bf77e00&scoped=true"
import script from "./CPU.vue?vue&type=script&lang=js"
export * from "./CPU.vue?vue&type=script&lang=js"
import style0 from "./CPU.vue?vue&type=style&index=0&id=1bf77e00&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf77e00",
  null
  
)

export default component.exports